define([
    "jquery",
    "underscore",
    "jquery/jquery.parsequery",
    "foundation/entries/plugins/foundation.util.mediaQuery"
], function($, _) {
    "use strict";

    const foundationMq = document.querySelector(".foundation-mq");
    const bodyFontSize = parseFloat(
        getComputedStyle(document.body)["font-size"]
    );
    const foundationMqSizes = $.parseQuery(
        getComputedStyle(foundationMq)["font-family"].replace(/"/g, "")
    );

    // Create a hash of breakpoint names to pixel sizes.
    return _.extend(
        // Defaults
        {
            small: 0,
            medium: 640,
            large: 1024,
            xlarge: 1200,
            xxlarge: 1440
        },
        // Read from Foundation's MQ element, multiply each of foundation's elements by the body base font size.
        _.mapObject(foundationMqSizes, function(emSize) {
            return Math.floor(parseFloat(emSize) * bodyFontSize);
        })
    );
});
